<template>
    <button
    class="button-remember-me-pad"
    :class="{ 'icon-only': !label }"
    @click.stop="emit('clicked')">
        <!-- Button Icon -->
        <app-icon v-if="icon" class="icon"/>
        <!-- Button label -->
        <div v-if="label" class="label">{{ label }}</div>
    </button>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'
/* Emmitters */
const emit = defineEmits(['clicked'])

/** Props received:
@label {String}
@icon {String}
*/
const props = defineProps({
    label: String,
	icon: String
})

/* Computed */
const appIcon = computed(() => {
    const icon = props.icon
	return defineAsyncComponent(() => import('@/assets/icons/' + icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.button-remember-me-pad {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    gap: 8px;

    height: 48px;

    padding: 0 16px;
    border-radius: 8px;

    @include H2-Regular;
    color: var(--secondary-dark-2);

    cursor: pointer;

    &.icon-only {
        width: 48px;
    }

    svg.icon {
        flex-shrink: 0;

        width: 24px;
        height: 24px;
        pointer-events: none;

        :deep(.change-color-fill) {
            fill: var(--secondary-dark-2);
        }
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: var(--button-remember-me-pad-state-hover);
        }
    }

    &:active {
        background-color: var(--button-remember-me-pad-state-press);
    }
}
</style>
